<!--  付电费申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        付电费申请
        <small>付电费申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 付电费申请
          </a>
        </li>
        <li class="active">付电费申请</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <!-- <div id="atptoolbar"></div> -->

      <div class="form-group overflow-hidden">
        <div class="col-sm-12">
          <form enctype="multipart/form-data" role="form" @change="submitFile">
            <div class="container-fluid">
              <div class="row">
                <!-- 上传文件 -->
                <div class="col-sm-6 col-md-6">
                  <div class="panel panel-default">
                    <input id="f_upload" type="file" class="file-loading" />
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    href="https://oss.xinyilin10.com/resource/template/e_flow_import_template_p1.xlsx"
                  >点击下载批量导入模板</a>
                </div>
              </div>
            </div>

            <!--<span id="import_text" v-html="submitCollectionFlowImport_text"></span>-->
          </form>
        </div>
      </div>

      <div v-for="(eFlow,index) in eFlowList" :key="index" class="e-flow-item">
        <br />
        <h4 class="text-primary">基站基础信息</h4>
        <hr />
        <div class="form-group">
          <button
            type="button"
            class="btn btn-primary pull-right"
            style="margin-right: 10px;"
            @click="showHistoryData(index)"
          >查看历史数据</button>
          <button
            type="button"
            class="btn btn-primary pull-right"
            style="margin-right: 10px;"
            @click="showEcharts(1,index)"
          >累计用电量</button>
          <button
            type="button"
            class="btn btn-primary pull-right"
            style="margin-right: 10px;"
            @click="showEcharts(2,index)"
          >最后表底数</button>
          <button
            type="button"
            class="btn btn-primary pull-right"
            style="margin-right: 10px;"
            @click="showEcharts(3,index)"
          >分段日耗</button>
        </div>
        <!--  信息展示区  -->
        <div class="col-sm-12 form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label">JT号：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                type="text"
                v-model="eFlow.stst_jtno"
                class="form-control"
                readonly
              />
            </div>
            <label class="col-sm-2 control-label">基站名称：</label>
            <div class="col-sm-4">
              <input
                name="stst_ercode"
                type="text"
                v-model="eFlow.stst_commname"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">运营商：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                type="text"
                v-model="eFlow.stst_comm"
                class="form-control"
                readonly
              />
            </div>
            <label class="col-sm-2 control-label">分管运营商：</label>
            <div class="col-sm-4">
              <input
                name="stst_ercode"
                type="text"
                v-model="eFlow.stst_subcomm"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">收电费单价：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                type="text"
                v-model="eFlow.stst_commelectricity"
                class="form-control"
                readonly
              />
            </div>
            <label class="col-sm-2 control-label">付电费单价：</label>
            <div class="col-sm-4">
              <input
                name="stst_ercode"
                type="text"
                v-model="eFlow.stst_ownerelectricity"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">局方合同起始日期：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                type="text"
                v-model="eFlow.stst_commcontractstar"
                class="form-control"
                readonly
              />
            </div>
            <label class="col-sm-2 control-label">局方合同终止日期：</label>
            <div class="col-sm-4">
              <input
                name="stst_ercode"
                type="text"
                v-model="eFlow.stst_commcontractend"
                class="form-control"
                readonly
              />
            </div>
          </div>
          <br />
          <h4 class="text-primary">本次申请的流水</h4>
          <hr />

          <div class="form-group">
            <label class="col-sm-2 control-label">上次查表时间：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                type="text"
                v-model="eFlow.上次查表时间"
                class="form-control"
                readonly
              />
            </div>
            <label class="col-sm-2 control-label">上次表底数：</label>
            <div class="col-sm-4">
              <input
                name="stst_ercode"
                type="text"
                v-model="eFlow.上次表底数"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">本次查表时间：</label>
            <div class="col-sm-4">
              <input
                name="stst_jtno"
                :id="forId('current_time',index)"
                type="text"
                v-model="eFlow.本次查表时间"
                class="form-control"
                @click="datePicker('current_time',index)"
              />
            </div>
            <label class="col-sm-2 control-label">本次表底数：</label>
            <div class="col-sm-4">
              <input name="stst_ercode" type="text" v-model="eFlow.本次表底数" class="form-control" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">度数：</label>
            <div class="col-sm-4">
              <input name="stst_jtno" type="text" v-model="eFlow.度数" class="form-control" />
            </div>
            <label class="col-sm-2 control-label">金额：</label>
            <div class="col-sm-4">
              <input name="stst_ercode" type="text" v-model="eFlow.金额" class="form-control" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">单价：</label>
            <div class="col-sm-4">
              <input name="stst_jtno" type="text" v-model="eFlow.单价" class="form-control" />
            </div>
            <label class="col-sm-2 control-label">支付方式：</label>
            <div class="col-sm-4">
              <select name="stst_ercode" class="form-control" v-model="eFlow.支付方式">
                <option value>&nbsp;</option>
                <option value="现金">现金</option>
                <option value="网银">网银</option>
                <option value="支票">支票</option>
                <option value="电汇">电汇</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">付款公司：</label>
            <div class="col-sm-4">
              <input name="stst_jtno" type="text" v-model="eFlow.付款公司" class="form-control" />
            </div>
            <label class="col-sm-2 control-label">实际支付日期：</label>
            <div class="col-sm-4">
              <input name="stst_ercode" type="text" v-model="eFlow.实际支付日期" class="form-control" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">发票形式：</label>
            <div class="col-sm-4">
              <select name="invoice_type" class="form-control" v-model="eFlow.发票形式">
                <option value="无">无</option>
                <option value="专票">专票</option>
                <option value="普票">普票</option>
                <option value="收据">收据</option>
                <option value="白条">白条</option>
              </select>
            </div>
            <label class="col-sm-2 control-label">发票税率：</label>
            <div class="col-sm-4">
              <select name="stst_ercode" class="form-control" v-model="eFlow.发票税率">
                <option value>&nbsp;</option>
                <option value="0">0</option>
                <option value="0.03">3%</option>
                <option value="0.05">5%</option>
                <option value="0.06">6%</option>
                <option value="0.10">10%</option>
                <option value="0.11">11%</option>
                <option value="0.13">13%</option>
                <option value="0.16">16%</option>
                <option value="0.17">17%</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal-footer -->
    <div class="modal-footer">
      <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
      <button type="button" class="btn btn-primary" @click="submit">确定</button>
    </div>

    <!-- <v-applypaytaskpaymentmodal ref="applyPayTaskPaymentModal"></v-applypaytaskpaymentmodal> -->
    <v-echartsEFlow ref="echartsEFlow"></v-echartsEFlow>
    <v-applyHisData ref="applyHisData"></v-applyHisData>
  </div>
</template>

<script>
// import applyPayTaskPaymentModal from "./applyPayTaskPaymentModal";
import echartsEFlow from "./echartsEFlow"; // 折线图
import applyHisData from "./applyHistoryData"; // 历史数据

export default {
  name: "applyPayTaskPayment",
  data() {
    return {
      // eFlowList: [], // 流水申请单列表
      eFlowList: [], // 流水申请单列表
    };
  },

  components: {
    // datepicker,
    "v-echartsEFlow": echartsEFlow,
    "v-applyHisData":applyHisData,
  },

  mounted: function () {},

  methods: {
    // 显示历史数据
    showHistoryData:function(index){
      let self = this;
      $("#apply_his_data_modal").modal("show");
      this.$refs.applyHisData.showHisData(self.eFlowList[index]);
    },
    // 动态生成id
    forId: function (_id, index) {
      return _id + "_" + index;
    },
    // 日历初始化
    datePicker: function (elementId, index) {
      let self = this;
      WdatePicker({
        el: elementId + "_" + index,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {},
        oncleared: function () {
          self[elementId] = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    // param (折线图类型,索引值)
    showEcharts: function (param, index) {
      let self = this;
      $("#echarts_e_flow_modal").modal("show");
      this.$refs.echartsEFlow.echartsDateInt(param,self.eFlowList[index]);
      // console.log(param);
      // console.log("index", index);
    },
    submitFile: function (e) {
      let self = this;
      // console.log('___submitFile', this)
      // console.log('___submitFile e', e)
      let file = e.target.files[0];
      let param = new FormData(); //创建form对象
      param.append("file", file); //通过append向form对象添加数据
      console.log(param.get("file")); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
      };
      self.global.axiosPost(
        self,
        "e_flow_excel_covert_to_json/",
        param,
        (res) => {
          console.log("___获取到结果", res, res.status);
          if (res.status === "error") {
            alert(`以下基站名称未匹配,请在基站列表核实:\n${res.unknow}`);
            return;
          }
          self.eFlowList = res.result;
          console.log("___ self.eFlowList", self.eFlowList);
        },
        function (res) {}
      );
    },

    submit: function () {
      // 发起流水导入申请
      let self = this;
      const company = localStorage.getItem("companyInfo");
      const formData = {
        公司ID: JSON.parse(company).id,
        流水信息: self.eFlowList,
        流水类型: 5, // [收费1 | 付费2 |批量收费 4|批量付费5| 预收费6|预付费7|补差价收8 | 补差价付 9]
      };

      console.log("___提交表单 formData", formData);
      self.global.axiosPost(
        self,
        "apply/10/",
        formData,
        function (res) {
          console.log("___提交付电费申请表单", res);
          if (res.status === "success") {
            alert("提交成功");

          }
        },
        function (res) {}
      );
    },
  },
};
</script>

<style scoped>
.e-flow-item {
  border: 1px solid white;
  overflow: hidden;
  font-size: 15px;
  line-height: 25px;
}

.e-flow-station-info {
  padding: 0 0 20px 20px;
}

.e-flow-form-info {
  padding: 0 0 20px 20px;
}

.e-flow-show-btn-panel {
  padding: 10px 10px 0 0;
  display: flex;
  justify-content: flex-end;
}

.e-flow-show-btn {
  margin: 5px;
}

.e-flow-show-btn-chart {
  height: 200px;
  background-color: #0e84b5;
}
</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyPayEBills.vue